import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export type PersonType = "PERSONNE_PHYSIQUE" | "PERSONNE_MORALE";
export type PersonTypeShort = "PP" | "PM";
export type PersonTypeFull = "Personne physique" | "Personne morale";

export function mapPersonType(type: PersonType): PersonTypeShort;
export function mapPersonType(
  type: PersonType,
  format: "short"
): PersonTypeShort;
export function mapPersonType(type: PersonType, format: "full"): PersonTypeFull;
export function mapPersonType(
  type: PersonType,
  format: "short" | "full" = "short"
) {
  if (format === "full") {
    return type === "PERSONNE_PHYSIQUE"
      ? "Personne physique"
      : "Personne morale";
  }
  return type === "PERSONNE_PHYSIQUE" ? "PP" : "PM";
}

// Nom ou prénom : lettres (accentuées), espaces, tirets, apostrophes (droite et typographique) et points,
// avec au moins une lettre. « N'Guessan », « Dj'Mel », « Jean-Marc », « J. Kouassi » sont des noms valides.
export const onlyLetters = (value: string): boolean => {
  const regex = /^(?=.*[A-Za-zÀ-ÖØ-öø-ÿ])[A-Za-zÀ-ÖØ-öø-ÿ\s.'’-]+$/;
  return regex.test(value);
};

// Numero local (indicatif pays stocke a part, ex. countryCode="+225") : la longueur du numero
// significatif varie d'un pays a l'autre (8 chiffres pour certains pays, 10 pour la CI, jusqu'a
// 15 pour d'autres selon l'UIT E.164) - une longueur fixe rejetait tout numero saisi avec un
// indicatif different de celui suppose par defaut.
export const isValidPhoneNumber = (value: string): boolean => {
  const regex = /^\d{8,15}$/;
  return regex.test(value);
};

// Numéro d'un prospect : exactement dix chiffres, comme le backend (`^\d{10}$` sur le téléphone du prospect, de
// l'entreprise et du déclarant). Un numéro de huit ou neuf chiffres recevrait un SMS puis serait refusé (400) à la création.
export const isValidProspectPhoneNumber = (value: string): boolean => {
  const regex = /^\d{10}$/;
  return regex.test(value);
};

// Vérifier le format email avec la même règle que le backend (prospect, entreprise, mise à jour) : un caractère
// accentué ou une extension de plus de six lettres passerait le front puis serait refusé (400) après l'envoi du code.
const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,6}$/;
export const isValidEmail = (value: string): boolean => {
  return emailRegex.test(value);
};

export const getDeviceFingerprint = async () => {
  // Chargement dynamique pour ne pas alourdir le bundle initial
  const { default: FingerprintJS } = await import(
    "@fingerprintjs/fingerprintjs"
  );
  const fp = await FingerprintJS.load();
  const result = await fp.get();

  return result.visitorId; // Empreinte unique
};
